














import { Component, Mixins } from 'vue-property-decorator';
import { ModalRoot } from './mixins/modal-root';
import LoaderCircular from '@/components/LoaderCircular.vue';
import Icon from '@/components/Icon.vue';

@Component({
  name: 'BaseModalSubContainer',
  components: {
    LoaderCircular,
    Icon,
  },
})
export default class BaseModalSubContainer extends Mixins(ModalRoot) {}
